import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "icon_fullscreen_on",
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.092",
  height: "28.092",
  viewBox: "0 0 28.092 28.092"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M17.823,28.717V24.948H21.91l-3.994-3.993,2.422-2.423,3.994,3.994V17.754H28.1V28.717Zm6.509-21.2L20.38,11.47,17.941,9.03l4.637-4.637H17.823V.625H28.1V11.588H24.332ZM.008,17.754H3.777v5.44l4.637-4.637L10.853,21,6.9,24.948h4.755v3.769H.008Zm10.87-8.682L8.455,11.494,3.777,6.816v4.772H.008V.625H11.656V4.393H6.2Z",
  transform: "translate(-0.008 -0.625)",
  fill: "#c5ab7c",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  id: "icon_fullscreen_off",
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.321",
  height: "28.092",
  viewBox: "0 0 28.321 28.092"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_561",
  "data-name": "Path 561",
  d: "M-.088,11.588V7.819H4L.005,3.826,2.427,1.4,6.421,5.4V.625h3.768V11.588ZM6.421,24.647,2.469,28.6.03,26.159l4.637-4.637H-.088V17.754H10.189V28.717H6.421ZM16.586.625h3.769v5.44l4.637-4.637,2.439,2.439L23.479,7.819h4.755v3.769H16.586ZM27.415,26.177,24.992,28.6l-4.678-4.678v4.772H16.545V17.73H28.193V21.5H22.736Z",
  transform: "translate(0.088 -0.625)",
  fill: "#c5ab7c",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isOn)
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("svg", _hoisted_4, _hoisted_6))
}